import React__default, { useState, useEffect, Fragment } from 'react';
import { CommonStyles } from '../BaseProps/index.es.js';
import { Radio } from './Radio.es.js';
import { Divider } from '../Divider/Divider.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div`
  ${CommonStyles}
`;
const RadioGroup = (_a) => {
  var _b = _a, {
    options,
    value,
    defaultValue,
    onChange,
    layout = "vertical",
    hasDivider = false
  } = _b, rest = __objRest(_b, [
    "options",
    "value",
    "defaultValue",
    "onChange",
    "layout",
    "hasDivider"
  ]);
  const showDivider = layout === "vertical" && hasDivider;
  const [initCheckedValue, setInitCheckedValue] = useState();
  useEffect(() => {
    setInitCheckedValue(value === void 0 ? defaultValue : value);
  }, []);
  return /* @__PURE__ */ React__default.createElement(Wrapper, __spreadValues({}, rest), options.map((opt, index, list) => /* @__PURE__ */ React__default.createElement(Fragment, {
    key: index
  }, /* @__PURE__ */ React__default.createElement(WrapperRadio, {
    layout,
    showDivider
  }, /* @__PURE__ */ React__default.createElement(Radio, {
    key: opt.value,
    onClick: () => onChange && onChange(opt.value),
    checked: (value === void 0 ? initCheckedValue : value) === opt.value,
    disabled: opt == null ? void 0 : opt.disabled
  }, opt.label)), showDivider && index !== list.length - 1 && /* @__PURE__ */ React__default.createElement(Divider, {
    gap: 8,
    color: "#e0e0e0"
  }))));
};
const WrapperRadio = styled.div(({ layout, showDivider }) => `
    display: ${layout === "vertical" ? "block" : "inline-flex"};
    margin-bottom: ${!showDivider ? "8px" : "unset"};
    margin-right: ${layout === "horizontal" ? "16px" : "unset"};
`);

export { RadioGroup };
